import { HStack, Heading, HeadingProps, Spacer } from "@chakra-ui/react";
import React from "react";

interface PropertyTableHeaderProps extends HeadingProps {
  button?: React.ReactNode;
}

export function PropertyTableHeader({ children, button, ...rest }: PropertyTableHeaderProps) {
  return (
    <HStack>
      <Heading
        as="h2"
        fontSize="16px"
        color="#316489"
        fontWeight="bold"
        textTransform="uppercase"
        margin="8px 0 8px 0"
        {...rest}
      >
        {children}
      </Heading>
      <Spacer />
      {button}
    </HStack>
  );
}
